import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "callback-view" }
const _hoisted_2 = { class: "callback-container" }
const _hoisted_3 = {
  key: 0,
  class: "processing"
}
const _hoisted_4 = {
  key: 1,
  class: "success"
}
const _hoisted_5 = {
  key: 2,
  class: "error"
}

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';
import PrimaryButton from '@/components/UI/PrimaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpotifyCallbackView',
  setup(__props) {

const router = useRouter();
const { handleCallback } = useSpotifyAuth();

const isProcessing = ref(true);
const success = ref(false);
const errorMessage = ref('');

async function processCallback() {
  try {
    const result = await handleCallback(); // NEUE PKCE-Version

    if (result) {
      success.value = true;
      // Kurze Verzögerung für UX, dann redirect
      setTimeout(() => {
        // Wenn du direkt ins Spiel willst, nimm '/game'
        router.replace('/'); 
      }, 1500);
    } else {
      success.value = false;
      errorMessage.value = 'Die Anmeldung bei Spotify ist fehlgeschlagen.';
    }
  } catch (error) {
    success.value = false;
    errorMessage.value =
      error instanceof Error ? error.message : 'Unbekannter Fehler beim Spotify-Login';
  } finally {
    isProcessing.value = false;
  }
}

function goHome() {
  router.replace('/');
}

onMounted(() => {
  // WICHTIG: PKCE liest jetzt ?code=...&state=... aus window.location.search
  processCallback();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isProcessing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "spinner" }, null, -1),
            _createElementVNode("h2", null, "Verbinde mit Spotify...", -1),
            _createElementVNode("p", null, "Einen Moment bitte", -1)
          ]))]))
        : (success.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "success-icon" }, "✓", -1),
              _createElementVNode("h2", null, "Erfolgreich verbunden!", -1),
              _createElementVNode("p", null, "Du wirst weitergeleitet...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "error-icon" }, "✕", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Verbindung fehlgeschlagen", -1)),
              _createElementVNode("p", null, _toDisplayString(errorMessage.value), 1),
              _createVNode(PrimaryButton, { onClick: goHome }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Zurück zur Startseite ", -1)
                ]))]),
                _: 1
              })
            ]))
    ])
  ]))
}
}

})